import React, { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import UserIcon from "@styles/all-images/icons/bg-user.svg";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "@/store";
import actionsHandler from "@/store/actions/actionHandler";
import CustomTable from "@/components/common/table/CustomTable";

const ProfileAssignedUsers = () => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const { id } = useParams(); // Get ID from route
  const [forceRefresh, setForceRefresh] = useState(false);
  const [profileName, setProfileName] = useState("");

  const handleFetch = useCallback(
    async (params: {
      page: number;
      limit: number;
      search?: string;
      sortColumn?: string;
      sortDirection?: "asc" | "desc";
    }) => {
      try {
        const { getAllData } = actionsHandler("assignProfileUserList");
        const response = await dispatch(
          getAllData({
            limit: params.limit || 10,
            page: params.page || 1,
            search: params.search || "",
            customParams: [id + "/"],
            customQuery: new URLSearchParams({
              ...(params.sortColumn && {
                ordering:
                  (params.sortDirection === "asc" ? "" : "-") +
                  params.sortColumn,
              }),
            }).toString(),
          }),
        );
        return response;
      } catch (error) {
        console.error("Error fetching assigned users:", error);
        return {
          data: {
            data: [],
            meta: { count: 0, page: 1, limit: 10 },
          },
        };
      }
    },
    [dispatch, id],
  );

  useEffect(() => {
    const fetchProfileName = async () => {
      try {
        const { getAllData } = actionsHandler("permissionProfileById");
        const response = await dispatch(
          getAllData({
            customParams: [id + "/"],
          }),
        );
        setProfileName(response.data?.name || "");
      } catch (error) {
        console.error("Error fetching profile name:", error);
      }
    };
    fetchProfileName();
  }, [id, dispatch]);

  const columns = [
    {
      header: "Client Name",
      accessor: (row: any) => (
        <div className="tw-flex tw-items-center tw-gap-2">
          <img src={row.profile_picture || UserIcon} alt="User Icon" />
          <span>{row.name}</span>
        </div>
      ),
      sortable: true,
      sortKey: "name",
    },
    {
      header: "Company Name",
      accessor: (row: any) => row.company_name || "-",
      sortable: true,
      sortKey: "company_name",
    },
    {
      header: "Email Address",
      accessor: "email",
      sortable: true,
      sortKey: "email",
    },
    {
      header: "Contact Number",
      accessor: "phone",
      sortable: true,
      sortKey: "phone",
    },
  ];

  return (
    <div>
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/profile-management">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Profile Assigned Users
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="tw-p-6 tw-mt-[147px]">
        <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden">
          <CustomTable
            columns={columns}
            fetchData={handleFetch}
            forceRefresh={forceRefresh}
            setForceRefresh={setForceRefresh}
            customTableTitle={profileName}
            noDataMessage={`No assigned users found`}
            noSearchDataMessage={`No matching assigned users found`}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileAssignedUsers;
